import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import axios from "axios";

const Sidebar = () => {

  const user = JSON.parse(
    localStorage.getItem("user")
  );

  const token = user?.token;

  const SUPREME_EMAIL =
    "joysworldsecondary@gmail.com";

  const location = useLocation();

  // ====================================
  // SUPPORT UNREAD COUNT
  // ====================================
  const [supportUnreadCount,
    setSupportUnreadCount] =
    useState(0);

  // ====================================
  // FETCH SUPPORT TICKETS
  // ====================================
  const fetchSupportUnreadCount =
    async () => {

      try {

        const res = await axios.get(
          "/api/admin/feedback/tickets",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const totalUnread =
          res.data.tickets.reduce(
            (acc, ticket) =>
              acc +
              (ticket.adminUnreadCount || 0),
            0
          );

        setSupportUnreadCount(
          totalUnread
        );

      } catch (error) {
        console.error(
          "Admin Support Count Error:",
          error
        );
      }
    };

  // ====================================
  // INITIAL FETCH + POLLING
  // ====================================
  useEffect(() => {

    fetchSupportUnreadCount();

    const interval =
      setInterval(() => {
        fetchSupportUnreadCount();
      }, 30000);

    return () =>
      clearInterval(interval);

  }, []);

  const navLinks = [

    {
      name: "Dashboard Overview",
      path: "/admin/overview",
    },

    {
      name: "User Management",
      path: "/admin/users",
    },

    {
      name: "Exam Cycle",
      path: "/admin/exam-cycle",
    },

    {
      name: "Notes",
      path: "/admin/notes",
    },

    {
      name: "The Hindu Analysis",
      path: "/admin/editorials",
    },

    {
      name: "Monthly Magazine",
      path: "/admin/monthly-magazines",
    },

    {
      name: "MCQ Practice",
      path: "/admin/mcqs",
    },

    {
      name: "Mains Practice",
      path: "/admin/mains-practice",
    },

    {
      name: "Test Series",
      path: "/admin/test-series",
    },

    {
      name: "Study Plans",
      path: "/admin/plans",
    },

    {
      name: "Announcements",
      path: "/admin/announcements",
    },

    // ====================================
    // SUPPORT INBOX
    // ====================================
    {
      name: "Support Inbox",
      path: "/admin/support",
    },

    {
      name: "Profile Settings",
      path: "/admin/settings",
    },
  ];

  return (
    <div
      className="
        w-64
        bg-white
        dark:bg-gray-800
        shadow-lg
        min-h-screen
        p-5
        flex
        flex-col
        justify-between
        border-r
        border-gray-200
        dark:border-gray-700
      "
    >

      {/* TOP */}
      <div>

        {/* LOGO */}
        <h2
          className="
            text-2xl
            font-bold
            text-blue-600
            dark:text-blue-400
            mb-8
            text-center
          "
        >
          Admin Panel
        </h2>

        {/* NAVIGATION */}
        <nav className="flex flex-col gap-2">

          {navLinks.map((link) => {

            const isActive =
              location.pathname ===
              link.path;

            const isSupport =
              link.path ===
              "/admin/support";

            return (
              <Link
                key={link.path}

                to={link.path}

                className={`
                  relative
                  flex
                  items-center
                  justify-between
                  px-4
                  py-3
                  rounded-lg
                  font-medium
                  transition-all
                  duration-300

                  ${
                    isActive
                      ? `
                        bg-blue-600
                        text-white
                        shadow-lg
                      `
                      : `
                        text-gray-700
                        hover:bg-blue-100
                        dark:text-gray-300
                        dark:hover:bg-gray-700
                      `
                  }
                `}
              >

                <span>
                  {link.name}
                </span>

                {/* SUPPORT BADGE */}
                {isSupport &&
                  supportUnreadCount > 0 && (
                  <div
                    className="
                      min-w-[22px]
                      h-6
                      px-2
                      rounded-full
                      bg-gradient-to-r
                      from-pink-500
                      to-purple-500
                      text-white
                      text-xs
                      font-bold
                      flex
                      items-center
                      justify-center
                      shadow-lg
                      shadow-purple-500/30
                      animate-pulse
                    "
                  >
                    {supportUnreadCount > 99
                      ? "99+"
                      : supportUnreadCount}
                  </div>
                )}
              </Link>
            );
          })}

          {/* SUPERADMIN */}
          {user?.email ===
            SUPREME_EMAIL && (
            <Link
              to="/admin/superadmin-queue"

              className="
                block
                px-4
                py-3
                rounded-lg
                font-semibold
                text-red-600
                hover:bg-red-100
                dark:hover:bg-red-800
                transition-colors
                duration-300
              "
            >
              Superadmin Approval Panel
            </Link>
          )}
        </nav>
      </div>

      {/* BOTTOM */}
      <div
        className="
          text-center
          text-sm
          text-gray-500
          dark:text-gray-400
        "
      >
        Logged in as:{" "}
        {user?.name ||
          user?.username}
      </div>
    </div>
  );
};

export default Sidebar;